import React from 'react';

const Quantity = ({quantity, onChangeQuantity}) => {

  const onChange = (e) => {
    onChangeQuantity(e.target.value)
  }

  return (
    <div className='d-flex align-items-center quantity-block mt-2 mb-3'>
      <div className="flex-shrink-0 quantity-title">
        Quantity
      </div>
      <div className="flex-grow-1 ms-3">
        <input 
          type="number" 
          className='form-control quantity-input'
          min="1"
          value={quantity || "1"}
          onChange={onChange}/>
      </div>
    </div>
  )
}

export default Quantity;